import { combineReducers } from "redux";
import { feedbackReducer } from "./feedbackReducer";
import { selectedSurveyReducer } from "./selctedSurveyReducer";
import languageReducer from "./selectedLanguageReducer";
import philipsITReducer from "./philipsITReducer";
import experienceReducer from "./experienceReducer";
import { msTeamsReducer } from "./msTeamsReducer";
import selectionReducer from "./itServiceReducer";
import mobileTelephonyReducer from "./mobileTelephonyReducer";
import officeNetworkReducer from "./officeNetworkReducer";
import ITExperienceReducer from "./itExperienceReducer";
import digitalServiceReducer from "./digitalServiceReducer";
import commonCompReducer from "./commonComponentReducer";
import { RESET_STORE } from "../actions/resetStoreAction";
import selectedSubmitOptionReducer from "./submitPageComponentReducer";
import { landingPageReducer } from "./landingPageReducer";

const rootReducer = combineReducers({
  feedback: feedbackReducer,
  selectedSurvey:selectedSurveyReducer,
  language:languageReducer,
  philipsIT:philipsITReducer,
  experience:experienceReducer,
  msTeams: msTeamsReducer,
  itService:selectionReducer,
  mobileTelephony:mobileTelephonyReducer,
  officeNetwork: officeNetworkReducer,
  ITExperience: ITExperienceReducer,
  digitalService: digitalServiceReducer,
  commonComponent: commonCompReducer,
  submitComponent: selectedSubmitOptionReducer,
  landingPage: landingPageReducer
});

const appReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return rootReducer(state, action);
};

export default appReducer;
